





































import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from './components/BottomTabbar.vue';
import { getBaseInfo, getRule } from './api';

const baseUrl = '20231128GPXDPT';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  rule: string = "";
  TwoTabIndex: number = 0;
  TwoTabShow: boolean = false;
  showTwoTab: boolean = false;
  ThreeTabIndex: number = 0;
  ThreeTabShow: boolean = false;
  showThreeTab: boolean = false;
  FourTabIndex: number = 0;
  FourTabShow: boolean = false;
  showFourTab: boolean = false;
  ruleShow = false;
  tabs: any[] = [
    {
      title: '首页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '我承诺',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
    {
      title: '来学习',
      path: `/${baseUrl}/rule`,
      id: 3,
    },
    {
      title: '共惜粮',
      path: `/${baseUrl}/rule`,
      id: 4,
    },
  ];
  twoTab: any[] = [
    {
      title: '承诺H5',
      path: `/${baseUrl}/h5`,
      id: 1,
    },
    {
      title: '光盘打卡',
      path: `https://activity.cqcb.com/shangyou_activity/2022h2/guangpan20221223/home`,
      id: 2,
    },
    {
      title: '光盘咖啡',
      path: `https://activity.cqcb.com/shangyou_activity/2020h2/20210121GPYJ/home`,
      id: 3,
    },
  ];
  threeTab: any[] = [
    {
      title: '视频教学',
      path: `/${baseUrl}/news`,
      id: 1,
    },
    {
      title: '“吃得文明”大家谈',
      path: `/${baseUrl}/newsTwo`,
      id: 2,
    },
    {
      title: '大食物观手绘',
      path: `/${baseUrl}/newsThree`,
      id: 3,
    },
  ];
  fourTab: any[] = [
    {
      title: '街角体验',
      path: `https://activity.cqcb.com/shangyou_activity/2020h2/20210121GPYJ/act-home `,
      id: 1,
    },
    {
      title: '预约讲座',
      path: `/${baseUrl}/save`,
      id: 2,
    },
    {
      title: '讲师服务',
      path: `/${baseUrl}/newsFour`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '上游新闻“米宝宝街角”惜粮公益服务平台',
      url: location.href,
      subtitle: `上游新闻“米宝宝街角”惜粮公益服务平台`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '上游新闻“米宝宝街角”惜粮公益服务平台',
        subtitle: `上游新闻“米宝宝街角”惜粮公益服务平台`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    const det = await getRule();
    this.rule = det.data
  }

  handleRules() {
    this.ruleShow = !this.ruleShow;
  }

  handleRulesTwo() {
    this.$router.push('/20231128GPXDPT/activity');
  }

  activeTabChange(index: number) {
    if (index === 1) {
      this.showFourTab = false;
      this.showThreeTab = false;
      this.showTwoTab = !this.showTwoTab;
      this.TwoTabShow = true;
      this.ThreeTabShow = false;
      this.FourTabShow = false;
    } else if (index === 2) {
      this.showTwoTab = false;
      this.showFourTab = false;
      this.showThreeTab = !this.showThreeTab;
      this.ThreeTabShow = true;
      this.TwoTabShow = false;
    } else if (index === 3){
      this.showThreeTab = false;
      this.showTwoTab = false;
      this.showFourTab = !this.showFourTab;
      this.FourTabShow = true;
      this.TwoTabShow = false;
      this.ThreeTabShow = false;
    } else {
      this.showFourTab = false;
      this.showThreeTab = false;
      this.showTwoTab = false;
      this.TwoTabShow = false;
      this.ThreeTabShow = false;
      this.FourTabShow = false;
    }
  }

  toTwoTabChange(index: number, path: string) {
    this.closeTabChange();
    this.TwoTabIndex = index;
    if (index === 1 || index === 2){
      window.location.href = path;
    } else {
      this.$router.push(path);
    }
  }

  toThreeTabChange(index: number, path: string) {
    this.closeTabChange();
    this.ThreeTabIndex = index;
    this.$router.push(path);
  }

  toFourTabChange(index: number, path: string) {
    this.closeTabChange();
    this.ThreeTabIndex = index;
    if (index === 0 ){
      window.location.href = path;
    } else {
      this.$router.push(path);
    }
  }

  closeTabChange() {
    this.showFourTab = false;
    this.showThreeTab = false;
    this.showTwoTab = false;
    this.TwoTabShow = false;
    this.ThreeTabShow = false;
    this.FourTabShow = false;
  }
}
